import { plainToClass } from "class-transformer";

import { AnonymizedOrderForDriver } from "../models/AnonymizedOrderForDriver";
import type { AnonymizedPassenger } from "../models/AnonymizedPassenger";
import type { Order } from "../models/Order";

export function transformOrderToAnonymizedOrderForDriver(order: Order): AnonymizedOrderForDriver {
    const anonymizedOrder: AnonymizedOrderForDriver = {
        _id: order._id,
        departureAt: order.departureAt,
        originLocationId: order.originLocationId,
        destinationLocationId: order.destinationLocationId,
        pickupAddress: order.pickupAddress,
        dropoffAddress: order.dropoffAddress,
        passengers: [],
        vehicles: order.vehicles,
        tollPrice: order.tollPrice,
        tollFee: order.tollFee,
        additionalPrice: order.additionalPrice,
        additionalFee: order.additionalFee,
        vehicleTypesPricesFees: order.vehicleTypesPricesFees,
        contentLocations: order.contentLocations,
        customLocations: order.customLocations,
        acceptedAt: order.acceptedAt,
        declinedAt: order.declinedAt,
        cancelledAt: order.cancelledAt,
        confirmedAt: order.confirmedAt,
        driverNote: "",
        customerNote: order.customerNote,
        status: order.status,
        paymentMethod: order.paymentMethod,
        pricingCurrency: order.pricingCurrency,
        discountIds: order.discountIds,
        type: order.type,
    };

    order.passengers.map((passenger) => {
        const anonymizedPassenger: AnonymizedPassenger = {
            type: passenger.type,
            luggage: passenger.luggage,
            isAdult: passenger.isAdult,
            isChild: passenger.isChild,
            isLead: passenger.isLead,
            assignationId: passenger.assignationId || undefined,
        };

        anonymizedOrder.passengers.push(anonymizedPassenger);
    });

    return plainToClass(AnonymizedOrderForDriver, anonymizedOrder);
}
